import { useCallback, useState } from "react";
import { Instagram } from "lucide-react";
import { posterFor } from "@/lib/journey";
import { ShareCardDialog, coverDraw, loadImage } from "@/components/ShareCard";
import { drawStrip } from "@/components/GraduationShare";

const W = 1080;
const H = 1920;

const mono = (x, text, y, size, color) => {
  x.fillStyle = color;
  x.font = `${size}px 'Courier New', monospace`;
  x.fillText(text, W / 2, y);
};

// 1080x1920 Instagram Story: forest poster, "I'm on the wall.", the 8-scene strip, chosen wall name.
export const drawWallStoryCard = async (wallName) => {
  const c = document.createElement("canvas");
  c.width = W;
  c.height = H;
  const x = c.getContext("2d");
  x.fillStyle = "#FFFFFF";
  x.fillRect(0, 0, W, H);
  try { coverDraw(x, await loadImage(posterFor("m8")), W, H); } catch (e) { console.warn("Wall story poster failed to load:", e); }
  const g = x.createLinearGradient(0, 500, 0, H);
  g.addColorStop(0, "rgba(5,5,5,0.15)");
  g.addColorStop(0.45, "rgba(5,5,5,0.86)");
  g.addColorStop(1, "rgba(5,5,5,0.98)");
  x.fillStyle = g;
  x.fillRect(0, 0, W, H);
  const top = x.createLinearGradient(0, 0, 0, 360);
  top.addColorStop(0, "rgba(5,5,5,0.85)");
  top.addColorStop(1, "rgba(5,5,5,0)");
  x.fillStyle = top;
  x.fillRect(0, 0, W, 360);
  x.strokeStyle = "rgba(245,158,11,0.85)";
  x.lineWidth = 3;
  x.strokeRect(44, 44, W - 88, H - 88);
  x.textAlign = "center";
  mono(x, "T . A . C . C .", 170, 28, "#F59E0B");
  mono(x, "T H R O U G H   A D V E R S I T Y   C O M E S   C H A N G E", 214, 18, "#44403C");
  mono(x, "T H E   G R A D U A T E   W A L L", 560, 30, "#F59E0B");
  x.fillStyle = "#FFFFFF";
  x.font = "150px Georgia, serif";
  x.fillText("I'm on", W / 2, 740);
  x.font = "italic 150px Georgia, serif";
  x.fillStyle = "#6EE7B7";
  x.fillText("the wall.", W / 2, 900);
  await drawStrip(x, 1010, W);
  x.fillStyle = "#F59E0B";
  x.font = "italic 46px Georgia, serif";
  x.fillText(wallName ? `— ${wallName}` : "— a T.A.C.C. graduate", W / 2, 1300);
  x.fillStyle = "#44403C";
  x.font = "italic 32px Georgia, serif";
  x.fillText("All eight modules. Storm to forest. Proof, not promises.", W / 2, 1380);
  mono(x, "T A C C . L O V E   ·   # G R A D U A T E - W A L L", 1760, 22, "#F59E0B");
  return c;
};

export const WallShareCard = ({ wallName }) => {
  const [open, setOpen] = useState(false);
  const draw = useCallback(() => drawWallStoryCard(wallName), [wallName]);
  return (
    <>
      <button onClick={() => setOpen(true)} data-testid="wall-share-btn" className="btn-outline text-xs">
        <Instagram size={13} /> Story card
      </button>
      <ShareCardDialog
        open={open}
        onOpenChange={setOpen}
        draw={draw}
        story
        testId="wall-story-card"
        title="I'm on the wall."
        description="Instagram Story size (1080×1920) — the wall, all eight scenes, and how your card reads."
        fileName="TACC-on-the-wall.png"
        shareText="I'm on the T.A.C.C. Graduate Wall — all eight modules, storm to forest. tacc.love"
      />
    </>
  );
};
